module.exports = __webpack_public_path__ + "static/img/arrow_left.ee10535.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/arrow_left.png
// module id = 5+jg
// module chunks = 1